/* eslint-disable no-shadow */
const buttonStyles = require('components/Button/styles');
const React = require('react');
const PropTypes = require('prop-types');
const { wrapFunctionalComponent } = require('utils/framework').default;
const getBaseComponent = require('utils/framework/getBaseComponent').default;
const getStyledComponent = require('utils/framework/getStyledComponent').default;
const { compose, color, layout, space } = require('styled-system');
const theme = require('style/theme');
const uiUtils = require('utils/UI');

const StyledButton = getStyledComponent({
    InnerComp: getBaseComponent({
        elementType: 'button',
        isBasicElement: false,
        useRef: true
    }),
    styledProps: [
        props => [
            buttonStyles.size(props.buttonSize),
            buttonStyles[props.variant],
            props.block && {
                display: 'flex',
                width: '100%'
            },
            compose(color, layout, space),
            props.hasMinWidth && { minWidth: '14.5em' },
            props.css
        ]
    ]
});

const Button = React.forwardRef(({ size, ...props }, ref) => {
    return (
        <StyledButton
            __ref={ref}
            buttonSize={size}
            {...props}
            {...uiUtils.getAriaButtonProps('button', props)}
        />
    );
});

Button.propTypes = {
    /** Alternate button sizes - `sm` */
    size: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['xs', 'sm'])]),
    /** Button style variants */
    variant: PropTypes.oneOf(['secondary', 'primary', 'special', 'inverted', 'white', 'link']).isRequired,
    /** Full width of container; block element */
    block: PropTypes.bool,
    /** Set a minimum button width so element doesn’t appear too small */
    hasMinWidth: PropTypes.bool
};

Button.defaultProps = {
    theme,
    minWidth: '5.5em'
};

module.exports = wrapFunctionalComponent(Button, 'Button');
